import React from "react";
import {
    NewStyledBankCard,
    NewStyledBankTableColumns,
    StyledBankCardHeader,
    StyledBankLogo, StyledCrossedPremiumHeader, StyledDashedLine, StyledHr,
    StyledLimitSumPanel,
    StyledText4Oms
} from "./styles";
import {Text1, Text1Money, Text2, TextButton12} from "../../../../libs/uiKit/globalStyles";
import RedHint from "../../../../libs/uiKit/hint/RedHint";
import CollapsibleTable from "./CollapsibleTable";
import {stringToMoney, stringToNumber} from "../../../../libs/uiKit/utils";
import {Text4} from "../../../../libs/uiKit/globalStyledComponents";
import Input from "../../../../libs/uiKit/input";
import {RiskResultItem} from "./context";
import {useGlobalContext} from "../../../../apps/main/ui/GlobalContext";

const ResultItem: React.FC<{
    isSelected: boolean;
    isn: string;
    isnBank: string;
    name: string;
    sum: string;
    premium: string;
    logo: string;
    risks: RiskResultItem[];
    warning: string | null | undefined;
    needOms: boolean;
    fixedDiscount: number;
    promocode: string;
    setPromocode: (value: string) => void;
    showDiscountKv: boolean;
    setDiscountKv: (value: number | '') => void;
    discountKv: number | '';
    setDiscountSk: (value: number | '') => void;
    discountSk: number | '';
    isDataChanged: boolean;
    inputsDisabled?: boolean;
    buttonsNode?: React.ReactNode;
    oldPremium: string | null | undefined;
    discountBlockAllowed: boolean;
}> = ({
    isSelected,
    isn,
    isnBank,
    name,
    sum,
    premium,
    logo,
    risks,
    warning,
    needOms,
    fixedDiscount,
    promocode,
    setPromocode,
    showDiscountKv,
    discountKv,
    setDiscountKv,
    discountSk,
    setDiscountSk,
    isDataChanged,
    inputsDisabled,
    buttonsNode,
    oldPremium,
    discountBlockAllowed
    }) => {

    const {
        user: {
            restrictions: {
                maxDiscount
            }
        },
    } = useGlobalContext();

    const showDiscountSk = maxDiscount && maxDiscount > 0;

    const discountHeaderColor = fixedDiscount > 0 ? "#01A63E" : undefined;


    return <NewStyledBankCard key={`card-${isn}`} style={{maxWidth: "400px"}}>
        <StyledBankCardHeader>
            <Text2>
                {name}
                {warning && <RedHint text={warning} />}
            </Text2>
            <StyledBankLogo>
                <img alt={name} src={logo} />
            </StyledBankLogo>
        </StyledBankCardHeader>


        {risks.map((risk, index) =>
            <>
                <CollapsibleTable header1={risk.name || ""}
                                  header2={stringToMoney(risk.sum) + " ₽"}
                                  isOpen= {false}
                                  afterHeader={index === 0 && needOms ? <StyledText4Oms>МЕДО</StyledText4Oms> : undefined}>
                    {index === 0 &&
                        <NewStyledBankTableColumns style={{gridTemplateColumns: "4fr 1fr 2fr", marginBottom: "1rem"}}>
                            {risk.borrowers.map((borrower) => (
                                <>
                                    <Text4 className="gray">{borrower?.name}</Text4>
                                    <Text4 className="gray">{stringToNumber(borrower?.tariff)}</Text4>
                                    <Text4 className="right">{stringToMoney(borrower?.premium)} ₽</Text4>
                                </>
                            ))}
                        </NewStyledBankTableColumns>}
                    {!(index === 0) &&
                        <NewStyledBankTableColumns style={{gridTemplateColumns: "4fr 2fr", marginBottom: "1rem"}}>
                            {risk.borrowers.map((borrower) => (
                                <>
                                    <Text4 className="gray">{borrower?.name}</Text4>
                                    <Text4 className="right">{stringToMoney(borrower?.premium)} ₽</Text4>
                                </>
                            ))}
                        </NewStyledBankTableColumns>}
                    {index === 0 && <StyledLimitSumPanel>Страховая сумма: <span>{sum}</span></StyledLimitSumPanel>}
                </CollapsibleTable>
                {(isSelected) &&
                    <>
                        <br/>
                        <StyledDashedLine/>
                    </>
                }
            </>
        )}


        {isSelected && discountBlockAllowed &&
            <>
                <CollapsibleTable header1="Скидка" header2={fixedDiscount + "%"} isOpen= {false} headerColor={discountHeaderColor}>
                    <br/>
                    <Input placeholder="Промокод" value={promocode} isDisabled={inputsDisabled} onChange={
                        (ev): void => {
                            setPromocode(ev.target.value);
                        }} />
                    <br/>
                    {showDiscountKv &&
                        <>
                            <Input placeholder="Скидка из КВ, %" type='number' isDisabled={inputsDisabled} value={discountKv} onChange={
                                (ev): void => {
                                    const re = /^\d+$/;
                                    if (ev.target.value === '' || (re.test(ev.target.value) && parseInt(ev.target.value, 10) <= 100)) {
                                        setDiscountKv(ev.target.value === '' ? '' : parseInt(ev.target.value, 10));
                                    }
                                }} />
                            <br/>
                        </>}
                    {showDiscountSk && <Input placeholder="Скидка от СК, %" type='number' isDisabled={inputsDisabled} value={discountSk} onChange={
                        (ev): void => {
                            const re = /^\d+$/;
                            if (ev.target.value === '' || (re.test(ev.target.value) && parseInt(ev.target.value, 10) <= 100)) {
                                setDiscountSk(ev.target.value === '' ? '' : parseInt(ev.target.value, 10));
                            }
                        }} />}

                </CollapsibleTable>
                <br/>
                <StyledDashedLine/>
            </>
        }

        {isSelected && !isDataChanged &&
            <>
                <NewStyledBankTableColumns style={{gridTemplateColumns: "1fr 2fr"}}>
                    <Text1>Итого</Text1>
                    <Text1Money className="right"><StyledCrossedPremiumHeader>{oldPremium}</StyledCrossedPremiumHeader> &nbsp;{premium}</Text1Money>
                </NewStyledBankTableColumns>
            </>}

        {buttonsNode}

    </NewStyledBankCard>
}

export default ResultItem;